import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Button } from "semantic-ui-react";

const BalanceCardButton = ({ customPath, hiddenTransferButton } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`profile.${key}`);

  const { depositPath, transferPath } = customPath || {};

  const navigate = useNavigate();

  return (
    <>
      <Button
        type="button"
        onClick={() => {
          navigate(depositPath || "../../profile/deposit");
        }}
        content={i18n("deposit")}
        className="!bg-main-color !text-white !py-[13px]"
        size="xl"
        icon={`add circle`}
      />
      {hiddenTransferButton || (
        <Button
          type="button"
          onClick={() => {
            navigate(transferPath || "../../profile/data/point-query");
          }}
          content={i18n("transfer")}
          className="!bg-green-400 !text-white !py-[13px] !px-[7px]"
          size="xl"
          icon={`exchange`}
        />
      )}
    </>
  );
};

export default BalanceCardButton;
